<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.spec.search.name')" prop="name">
                <a-input v-model="queryParam.name" :placeholder="$t('views.spec.search.namePlaceholder')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.spec.search.isCalculation')" prop="isCalculation">
                <a-select v-model="queryParam.isCalculation" :placeholder="$t('views.spec.search.isCalculationPlaceholder')" allow-clear>
                  <a-select-option v-for="item in yesNoCalcOptions" :key="item.value" :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.spec.search.isConflict')" prop="isConflict">
                <a-select v-model="queryParam.isConflict" :placeholder="$t('views.spec.search.isConflictPlaceholder')" allow-clear>
                  <a-select-option v-for="item in yesNoOptions" :key="item.value" :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.spec.search.type')" prop="type">
                <a-select v-model="queryParam.type" :placeholder="$t('views.spec.search.typePlaceholder')" allow-clear>
                  <a-select-option v-for="item in typeOptions" :key="item.value" :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.spec.search.isRequired')" prop="isRequired">
                <a-select v-model="queryParam.isRequired" :placeholder="$t('views.spec.search.isRequiredPlaceholder')" allow-clear>
                  <a-select-option v-for="item in yesNoRequiredOptions" :key="item.value" :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.spec.search.isCustomization')" prop="isCustomization">
                <a-select v-model="queryParam.isCustomization" :placeholder="$t('views.spec.search.isCustomizationPlaceholder')" allow-clear>
                  <a-select-option v-for="item in yesNoOptions" :key="item.value" :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.spec.search.identityRestrictions')" prop="identityRestrictions">
                <a-select v-model="queryParam.identityRestrictions" :placeholder="$t('views.spec.search.identityRestrictionsPlaceholder')" allow-clear>
                  <a-select-option v-for="item in identityOptions" :key="item.value" :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.spec.search.isPrompt')" prop="isPrompt">
                <a-select v-model="queryParam.isPrompt" :placeholder="$t('views.spec.search.isPromptPlaceholder')" allow-clear>
                  <a-select-option v-for="item in yesNoPromptOptions" :key="item.value" :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.spec.search.isDensity')" prop="isDensity">
                <a-select v-model="queryParam.isDensity" :placeholder="$t('views.spec.search.isDensityPlaceholder')" allow-clear>
                  <a-select-option v-for="item in yesNoOptions" :key="item.value" :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.spec.search.isThickness')" prop="isThickness">
                <a-select v-model="queryParam.isThickness" :placeholder="$t('views.spec.search.isThicknessPlaceholder')" allow-clear>
                  <a-select-option v-for="item in yesNoOptions" :key="item.value" :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.spec.search.isShow')" prop="isShow">
                <a-select v-model="queryParam.isShow" :placeholder="$t('views.spec.search.isShowPlaceholder')" allow-clear>
                  <a-select-option v-for="item in yesNoOptions" :key="item.value" :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="24" :sm="24">
              <span class="table-page-search-submitButtons" style="float: right; overflow: hidden;">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('views.spec.btn.query') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('views.spec.btn.reset') }}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <!-- 权限点（暂时停用，后续可能恢复）
          - user:spec:add
          - user:spec:edit
          - user:spec:remove
        -->
        <a-button v-hasPermi="['user:spec:add']" type="primary" @click="$refs.createForm.handleAdd()">
          <a-icon type="plus" />{{ $t('views.spec.btn.add') }}
        </a-button>
        <a-button v-hasPermi="['user:spec:edit']" type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)">
          <a-icon type="edit" />{{ $t('views.spec.btn.edit') }}
        </a-button>
<!--        <a-button v-hasPermi="['user:spec:remove']" type="danger" :disabled="multiple" @click="handleDelete">-->
<!--          <a-icon type="delete" />{{ $t('views.spec.btn.delete') }}-->
<!--        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 选项列表抽屉 -->
      <spec-option
        ref="specOptionDrawer"
        :drawer="true"
      />
      <!-- 数据展示 :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"

        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 'max-content' }"
      >
        <span slot="isCalculation" slot-scope="text, record">
          {{ formatEnum(record.isCalculation, yesNoCalcOptions) }}
        </span>
        <span slot="isConflict" slot-scope="text, record">
          {{ formatEnum(record.isConflict, yesNoOptions) }}
        </span>
        <span slot="type" slot-scope="text, record">
          {{ formatEnum(record.type, typeOptions) }}
        </span>
        <span slot="isRequired" slot-scope="text, record">
          {{ formatEnum(record.isRequired, yesNoRequiredOptions) }}
        </span>
        <span slot="isCustomization" slot-scope="text, record">
          {{ formatEnum(record.isCustomization, yesNoOptions) }}
        </span>
        <span slot="identityRestrictions" slot-scope="text, record">
          {{ formatEnum(record.identityRestrictions, identityOptions) }}
        </span>
        <span slot="isPrompt" slot-scope="text, record">
          {{ formatEnum(record.isPrompt, yesNoPromptOptions) }}
        </span>
        <span slot="isThickness" slot-scope="text, record">
          {{ formatEnum(record.isThickness, yesNoOptions) }}
        </span>
        <span slot="isDensity" slot-scope="text, record">
          {{ formatEnum(record.isDensity, yesNoOptions) }}
        </span>
        <span slot="isShow" slot-scope="text, record">
          {{ formatEnum(record.isShow, yesNoOptions) }}
        </span>
        <span slot="sort" slot-scope="text, record">
          <a-input-number
            :value="record.sort"
            :min="0"
            :disabled="!canEdit"
            style="width: 100px"
            @change="(value) => handleSortChange(record, value, 'sort')"
          />
        </span>
        <span slot="status" slot-scope="text, record">
          <a-switch
            :checked="record.status == 1 || record.status == '1'"
            :disabled="!canEdit"
            @change="(checked) => handleStatusChange(record, checked)"
          />
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['user:spec:edit']"  />
          <a v-hasPermi="['user:spec:edit']" @click="$refs.createForm.handleUpdate(record, undefined)">
            <a-icon type="edit" />{{ $t('views.spec.btn.edit') }}
          </a>
          <a-divider type="vertical" v-hasPermi="['user:spec:option']" />
          <a v-hasPermi="['user:spec:option']" @click="openSpecOptionDrawer(record)">
            <a-icon type="unordered-list" />{{ $t('views.spec.action.optionList') }}
          </a>
<!--          <a-divider type="vertical" v-hasPermi="['user:spec:remove']" v-if="record.id != '648198583975288832' && record.id != '647455418200788993' && record.id != '647448821500116992'" />-->
<!--          <a v-hasPermi="['user:spec:remove']" @click="handleDelete(record)" v-if="record.id != '648198583975288832' && record.id != '647455418200788993' && record.id != '647448821500116992'">-->
<!--            <a-icon type="delete" />{{ $t('views.spec.btn.delete') }}-->
<!--          </a>-->
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="paginationShowTotal"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageSpec, delSpec, updateSpecSort, updateSpecStatus } from '@/api/user/spec'
import CreateForm from './modules/CreateForm'
import SpecOption from '../specOption/index.vue'
import { tableMixin } from '@/store/table-mixin'
import auth from '@/plugins/auth'

export default {
  name: 'Spec',
  components: {
    CreateForm,
    SpecOption
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      columns: [],
      // 查询参数
      queryParam: {
        name: null,
        isCalculation: null,
        isConflict: null,
        type: null,
        isRequired: null,
        isCustomization: null,
        identityRestrictions: null,
        isPrompt: null,
        isDensity: null,
        isThickness: null,
        isShow: null,
        content: null,
        status: null,
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  filters: {
  },
  created () {
    this.buildColumns()
    this.getList()
  },
  computed: {
    canEdit () {
      return auth.hasPermi('user:spec:edit')
    },
    yesNoOptions () {
      return [
        { value: 0, label: this.$t('views.spec.enum.no') },
        { value: 1, label: this.$t('views.spec.enum.yes') }
      ]
    },
    yesNoCalcOptions () {
      return [
        { value: 0, label: this.$t('views.spec.enum.calcNo') },
        { value: 1, label: this.$t('views.spec.enum.calcYes') }
      ]
    },
    yesNoRequiredOptions () {
      return [
        { value: 0, label: this.$t('views.spec.enum.requiredNo') },
        { value: 1, label: this.$t('views.spec.enum.requiredYes') }
      ]
    },
    yesNoPromptOptions () {
      return [
        { value: 0, label: this.$t('views.spec.enum.promptNo') },
        { value: 1, label: this.$t('views.spec.enum.promptYes') }
      ]
    },
    identityOptions () {
      return [
        { value: 0, label: this.$t('views.spec.enum.identityNormal') },
        { value: 1, label: this.$t('views.spec.enum.identityPro') }
      ]
    },
    typeOptions () {
      return [
        { value: 0, label: this.$t('views.spec.enum.typeSingle') },
        { value: 1, label: this.$t('views.spec.enum.typeMulti') }
      ]
    }
  },
  watch: {
    '$i18n.locale' () {
      this.buildColumns()
    }
  },
  methods: {
    buildColumns () {
      const t = k => this.$t(k)
      this.columns = [
        { title: t('views.spec.column.id'), dataIndex: 'id', ellipsis: true, align: 'center' },
        { title: t('views.spec.column.name'), dataIndex: 'name', ellipsis: true, align: 'center' },
        { title: t('views.spec.column.nameEn'), dataIndex: 'nameEn', ellipsis: true, align: 'center' },
        {
          title: t('views.spec.column.isCalculation'),
          dataIndex: 'isCalculation',
          scopedSlots: { customRender: 'isCalculation' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: t('views.spec.column.isConflict'),
          dataIndex: 'isConflict',
          scopedSlots: { customRender: 'isConflict' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: t('views.spec.column.type'),
          dataIndex: 'type',
          scopedSlots: { customRender: 'type' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: t('views.spec.column.isRequired'),
          dataIndex: 'isRequired',
          scopedSlots: { customRender: 'isRequired' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: t('views.spec.column.isCustomization'),
          dataIndex: 'isCustomization',
          scopedSlots: { customRender: 'isCustomization' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: t('views.spec.column.identityRestrictions'),
          dataIndex: 'identityRestrictions',
          scopedSlots: { customRender: 'identityRestrictions' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: t('views.spec.column.isPrompt'),
          dataIndex: 'isPrompt',
          scopedSlots: { customRender: 'isPrompt' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: t('views.spec.column.isDensity'),
          dataIndex: 'isDensity',
          scopedSlots: { customRender: 'isDensity' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: t('views.spec.column.isThickness'),
          dataIndex: 'isThickness',
          scopedSlots: { customRender: 'isThickness' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: t('views.spec.column.isShow'),
          dataIndex: 'isShow',
          scopedSlots: { customRender: 'isShow' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: t('views.spec.column.sort'),
          dataIndex: 'sort',
          scopedSlots: { customRender: 'sort' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: t('views.spec.column.status'),
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: t('views.spec.column.createTime'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: t('views.spec.column.operation'),
          dataIndex: 'operation',
          width: 200,
          fixed: 'right',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    },
    paginationShowTotal (total) {
      return this.$t('views.spec.pagination.total', { total })
    },
    formatEnum (value, options) {
      if (value === null || value === undefined || value === '') {
        return ''
      }
      const numVal = Number(value)
      const hit = (options || []).find(o => Number(o.value) === numVal)
      return hit ? hit.label : String(value)
    },
    /** 查询规格列表 */
    getList () {
      this.loading = true
     pageSpec(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    openSpecOptionDrawer (record) {
      const specId = record && record.id ? record.id : null
      if (this.$refs.specOptionDrawer && this.$refs.specOptionDrawer.openDrawer) {
        this.$refs.specOptionDrawer.openDrawer(specId)
      }
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        name: undefined,
        isCalculation: undefined,
        isConflict: undefined,
        type: undefined,
        isRequired: undefined,
        isCustomization: undefined,
        identityRestrictions: undefined,
        isPrompt: undefined,
        isDensity: undefined,
        isThickness: undefined,
        isShow: undefined,
        content: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('views.spec.confirm.deleteTitle'),
        content: this.$t('views.spec.confirm.deleteContent', { ids: ids }),
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delSpec(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                that.$t('views.spec.msg.deleteSuccess'),
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('views.spec.confirm.exportTitle'),
        content: this.$t('views.spec.confirm.exportContent'),
        onOk () {
          that.download('user/spec/export', {
            ...that.queryParam
          }, that.$t('views.spec.export.filename', { time: new Date().getTime() }))
        },
        onCancel () {}
      })
    },
    /** 状态开关变更 */
    handleStatusChange (record, checked) {
      if (!this.canEdit) {
        return
      }
      const statusValue = checked ? 1 : 0
      updateSpecStatus({ id: record.id, status: statusValue }).then(() => {
        record.status = statusValue
        this.$message.success(this.$t('views.spec.msg.statusOk'))
        this.getList()
      }).catch(() => {
        this.$message.error(this.$t('views.spec.msg.statusFail'))
      })
    },
    /** 排序值变更 */
    handleSortChange (record, value, fieldName) {
      if (!this.canEdit) {
        return
      }
      if (value === null || value === undefined) {
        return
      }
      updateSpecSort({ id: record.id, sort: value }).then(() => {
        record[fieldName] = value
        this.$message.success(this.$t('views.spec.msg.sortOk'))
        this.getList()
      }).catch(() => {
        this.$message.error(this.$t('views.spec.msg.sortFail'))
      })
    }
  }
}
</script>
